import React from 'react';

export default function Quote() {
  return (
    <div className="quote">
      <p>
        Mathematics is not about numbers,equations,computation,or algorithms:
        It is about understanding. -William Paul Thurston
      </p>
    </div>
  );
}
